import { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import {
  GET_DAILY_CHALLENGES_QUIZ,
  GET_DAILY_CHALLENGE_SUMMARY,
  UPDATE_QUESTIONS_MAYBE_LATER,
  SAVE_USER_QUIZ_ANSWERS
} from "../../constant/Apipath";
import EarnBuilderBucksCard from "../rewards-store/EarnBuilderBucksCard";
import { BIBlue, BIYellow, BIGreen, BIGrey } from "../../assets/helpers";
import bucksIcon from "../../assets/images/bucks.png";

// Inject keyframe animations directly into document head
if (typeof document !== "undefined") {
  const styleTag = document.createElement("style");
  styleTag.innerHTML = `
    @keyframes glow-border {
      0% { border-color: rgba(8, 61, 184, 0.2); box-shadow: 0 4px 20px rgba(0,0,0,0.05); }
      50% { border-color: rgba(255, 188, 10, 0.6); box-shadow: 0 4px 25px rgba(255, 188, 10, 0.15); }
      100% { border-color: rgba(8, 61, 184, 0.2); box-shadow: 0 4px 20px rgba(0,0,0,0.05); }
    }
    @keyframes pulse-flame {
      0% { transform: scale(1); filter: drop-shadow(0 0 2px rgba(255, 152, 0, 0.6)); }
      50% { transform: scale(1.15); filter: drop-shadow(0 0 8px rgba(255, 152, 0, 0.9)); }
      100% { transform: scale(1); filter: drop-shadow(0 0 2px rgba(255, 152, 0, 0.6)); }
    }
    @keyframes confetti-pop {
      0% { transform: translateY(0) scale(0) rotate(0deg); opacity: 0; }
      10% { opacity: 1; }
      100% { transform: translateY(var(--translate-y, -250px)) translateX(var(--translate-x, 0px)) scale(var(--scale, 1)) rotate(var(--rotate, 360deg)); opacity: 0; }
    }
    @keyframes countup-effect {
      0% { transform: scale(0.9); opacity: 0.7; }
      50% { transform: scale(1.1); opacity: 1; }
      100% { transform: scale(1); }
    }
    @keyframes slide-up {
      from { transform: translateY(20px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    
    /* Modern gamified select options styling */
    .flex-container-horizontal {
      background-color: #f8f9fa !important;
      border: 2px solid #e9ecef !important;
      border-radius: 12px !important;
      margin-bottom: 12px !important;
      padding: 6px 16px !important;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
      cursor: pointer !important;
      display: flex !important;
      align-items: center !important;
      width: 100% !important;
    }
    .flex-container-horizontal:hover {
      border-color: #083DB8 !important;
      background-color: rgba(8, 61, 184, 0.02) !important;
      transform: translateY(-2px) !important;
    }
    .flex-container-horizontal:has(.Mui-checked) {
      border-color: #083DB8 !important;
      background-color: rgba(8, 61, 184, 0.06) !important;
      box-shadow: 0 4px 15px rgba(8, 61, 184, 0.12) !important;
    }
    .flex-container-horizontal .MuiCheckbox-root {
      color: #adb5bd !important;
      transition: color 0.2s ease !important;
    }
    .flex-container-horizontal .MuiCheckbox-root.Mui-checked {
      color: #083DB8 !important;
    }
    .flex-container-horizontal .MuiListItemText-primary {
      font-weight: 800 !important;
      color: #2b303a !important;
      font-size: 15px !important;
      letter-spacing: -0.2px !important;
    }
    
    /* Modern inputs & datepicker styling */
    .MuiDialog-content .MuiOutlinedInput-root {
      border-radius: 12px !important;
      background-color: #f8f9fa !important;
      transition: all 0.2s ease !important;
    }
    .MuiDialog-content .MuiOutlinedInput-notchedOutline {
      border-color: #e9ecef !important;
      border-width: 1.5px !important;
    }
    .MuiDialog-content .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #083DB8 !important;
      border-width: 2px !important;
    }
    .MuiDialog-content .MuiInputLabel-root {
      font-weight: 600 !important;
      color: #8D8D8D !important;
    }
    .MuiDialog-content .MuiInputLabel-root.Mui-focused {
      color: #083DB8 !important;
    }
    
    /* Modern primary button */
    .MuiDialog-content .MuiButton-containedPrimary {
      border-radius: 12px !important;
      padding: 10px 24px !important;
      font-weight: 800 !important;
      font-size: 15px !important;
      background-color: #083DB8 !important;
      box-shadow: 0 4px 15px rgba(8, 61, 184, 0.3) !important;
      text-transform: none !important;
      transition: all 0.2s ease !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 6px !important;
    }
    .MuiDialog-content .MuiButton-containedPrimary:hover {
      background-color: #062A85 !important;
      box-shadow: 0 6px 20px rgba(8, 61, 184, 0.4) !important;
      transform: translateY(-1px) !important;
    }
  `;
  document.head.appendChild(styleTag);
}

const DailyChallengeCard = ({ refreshDashboard, initialSummary, autoOpenModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginData, builderBucksCount } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const accessToken = loginData?.accessToken;

  const [summary, setSummary] = useState(initialSummary || null);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showQuestModal, setShowQuestModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [animatedBalance, setAnimatedBalance] = useState(0);
  const [isCounterActive, setIsCounterActive] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState("");
  const [preChallengeBalance, setPreChallengeBalance] = useState(0);
  const [justCompleted, setJustCompleted] = useState(false);
  const [showStartModal, setShowStartModal] = useState(false);
  const [maybeLaterLoading, setMaybeLaterLoading] = useState(false);
  const [totalRewardBucks, setTotalRewardBucks] = useState(20);

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const utcNow = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds(),
        now.getUTCMilliseconds()
      );

      const utcMidnight = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        0,
        0,
        0,
        0
      );

      const diffMs = utcMidnight - utcNow;
      const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const pad = (num) => String(num).padStart(2, "0");
      setTimeRemaining(`${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`);
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (showCompleteModal) {
      const rewardVal = summary?.rewardBucks || 20;
      const targetBalance = builderBucksCount || 0;
      const startBalance = justCompleted ? Math.max(0, targetBalance - rewardVal) : targetBalance;

      setAnimatedBalance(startBalance);

      if (!justCompleted || rewardVal <= 0) {
        setAnimatedBalance(targetBalance);
        setIsCounterActive(false);
        return;
      }

      setIsCounterActive(true);
      let current = startBalance;
      const duration = 1500; // 1.5s duration
      const steps = rewardVal;
      const stepTime = Math.max(20, Math.floor(duration / steps));

      const timer = setInterval(() => {
        current += 1;
        if (current >= targetBalance) {
          setAnimatedBalance(targetBalance);
          setIsCounterActive(false);
          clearInterval(timer);
        } else {
          setAnimatedBalance(current);
        }
      }, stepTime);

      return () => clearInterval(timer);
    }
  }, [showCompleteModal, justCompleted, builderBucksCount, summary?.rewardBucks]);

  const checkIsMaybeLaterToday = () => {
    try {
      const storedDate = localStorage.getItem("dailyChallenge_maybeLaterDate");
      const storedVal = localStorage.getItem("dailyChallenge_maybeLater");
      const todayDateStr = new Date().toISOString().split("T")[0];
      return storedVal === "true" && storedDate === todayDateStr;
    } catch (e) {
      return false;
    }
  };

  const fetchData = async () => {
    if (!userId) return;
    try {
      setLoading(true);
      const summaryUrl = `${GET_DAILY_CHALLENGE_SUMMARY}${userId}`;
      const summaryRes = await Getrequestcall(summaryUrl, accessToken);
      const summaryData = summaryRes?.data?.data?.[0];
      setSummary(summaryData);

      const isMaybeLaterLocalToday = checkIsMaybeLaterToday();
      const isMaybeLater = isMaybeLaterLocalToday || summaryData?.questionsMaybelater === true;

      // If user chose maybe later today or API says questionsMaybelater is true, do not fetch quiz questions
      if (isMaybeLater) {
        setLoading(false);
        return;
      }

      const quizUrl = `${GET_DAILY_CHALLENGES_QUIZ}${userId}`;
      const quizRes = await Getrequestcall(quizUrl, accessToken);
      const questionsData = quizRes?.data?.data || [];
      setQuestions(questionsData);

      const totalBucksFromQuiz = questionsData.reduce((acc, q) => acc + (Number(q.bucks) || 0), 0);
      setTotalRewardBucks(totalBucksFromQuiz || summaryData?.rewardBucks || 20);

      const unanswered = questionsData.find((q) => !q.isAnswer);
      setCurrentQuestion(unanswered || null);

      if (
        summaryData?.isQuestionsAvailable === true &&
        !isMaybeLater &&
        summaryData?.completed !== true &&
        summaryData?.completed !== "true"
      ) {
        setShowStartModal(true);
      }
    } catch (error) {
      console.error("Error loading daily challenge data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMaybeLater = async () => {
    if (!userId) return;
    setMaybeLaterLoading(true);
    try {
      await Postrequestcall(UPDATE_QUESTIONS_MAYBE_LATER, { UserId: userId }, accessToken);

      // Store today's date and maybeLater flag in localStorage
      const todayDateStr = new Date().toISOString().split("T")[0];
      localStorage.setItem("dailyChallenge_maybeLaterDate", todayDateStr);
      localStorage.setItem("dailyChallenge_maybeLater", "true");

      setShowStartModal(false);

      // Fetch updated summary only (do NOT fetch quiz questions)
      const summaryUrl = `${GET_DAILY_CHALLENGE_SUMMARY}${userId}`;
      const summaryRes = await Getrequestcall(summaryUrl, accessToken);
      const updatedSummary = summaryRes?.data?.data?.[0];
      if (updatedSummary) {
        setSummary(updatedSummary);
      } else {
        setSummary((prev) =>
          prev ? { ...prev, questionsMaybelater: true } : { questionsMaybelater: true }
        );
      }
    } catch (error) {
      console.error("Error updating maybe later status:", error);
      setShowStartModal(false);
    } finally {
      setMaybeLaterLoading(false);
    }
  };

  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) return;
    if (userId) {
      didMountRef.current = true;
      fetchData();
    }
  }, [userId]);

  // Handle auto-open challenge modal when navigated from notification
  useEffect(() => {
    if (autoOpenModal && userId) {
      handleStartChallenge();
    }
  }, [autoOpenModal, userId]);

  // Generate random confetti style values
  const confettiParticles = useMemo(() => {
    if (!showCompleteModal) return [];
    return Array.from({ length: 45 }).map((_, i) => {
      const angle = (i / 45) * 360;
      const distance = 100 + Math.random() * 200;
      const tx = `${Math.cos((angle * Math.PI) / 180) * distance}px`;
      const ty = `${Math.sin((angle * Math.PI) / 180) * distance}px`;
      const colors = ["#FFBC0A", "#083DB8", "#28A745", "#FF5252", "#E040FB"];
      return {
        "--translate-x": tx,
        "--translate-y": ty,
        "--scale": 0.5 + Math.random() * 0.8,
        "--rotate": `${360 + Math.random() * 720}deg`,
        position: "absolute",
        width: Math.random() > 0.5 ? "10px" : "6px",
        height: Math.random() > 0.5 ? "10px" : "6px",
        borderRadius: Math.random() > 0.5 ? "50%" : "0%",
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
        animation: "confetti-pop 1.8s cubic-bezier(0.1, 0.8, 0.3, 1) forwards",
        animationDelay: `${Math.random() * 0.4}s`
      };
    });
  }, [showCompleteModal]);

  const handleStartChallenge = async () => {
    setJustCompleted(false);
    let questionsList = questions;

    // If questions are not yet loaded in state, fetch them on demand
    if (!questionsList || questionsList.length === 0) {
      try {
        const quizUrl = `${GET_DAILY_CHALLENGES_QUIZ}${userId}`;
        const quizRes = await Getrequestcall(quizUrl, accessToken);
        questionsList = quizRes?.data?.data || [];
        setQuestions(questionsList);
      } catch (err) {
        console.error("Error fetching quiz on start challenge:", err);
      }
    }

    if (!questionsList || questionsList.length === 0) {
      // If still no questions from API, check summary
      if (summary?.completed || isCompleted) {
        setShowCompleteModal(true);
      }
      return;
    }

    const unanswered = questionsList.find((q) => !q.isAnswer) || questionsList[0];
    if (unanswered) {
      setCurrentQuestion(unanswered);
      if (unanswered.quizType === "Select") {
        const ops = unanswered?.options?.split(";").filter((op) => op?.trim() !== "");
        const newOptions = ops.map((op) => ({
          isSelected: false,
          optionName: op,
          isTextField: false
        }));
        setOptions(newOptions);
      } else {
        setOptions([]);
      }
      setShowQuestModal(true);
    } else {
      setShowCompleteModal(true);
    }
  };

  const handleQuestionSubmit = async () => {
    if (!userId) return;
    try {
      const summaryUrl = `${GET_DAILY_CHALLENGE_SUMMARY}${userId}`;
      const summaryRes = await Getrequestcall(summaryUrl, accessToken);
      const summaryData = summaryRes?.data?.data?.[0];
      setSummary(summaryData);

      const quizUrl = `${GET_DAILY_CHALLENGES_QUIZ}${userId}`;
      const quizRes = await Getrequestcall(quizUrl, accessToken);
      const questionsData = quizRes?.data?.data || [];
      setQuestions(questionsData);

      if (refreshDashboard) {
        await refreshDashboard();
      }

      if (summaryData?.completed || questionsData.every((q) => q.isAnswer)) {
        setJustCompleted(true);
        setShowQuestModal(false);
        setShowCompleteModal(true);
      } else {
        const unanswered = questionsData.find((q) => !q.isAnswer);
        if (unanswered) {
          setCurrentQuestion(unanswered);
          if (unanswered.quizType === "Select") {
            const ops = unanswered?.options?.split(";").filter((op) => op?.trim() !== "");
            const newOptions = ops.map((op) => ({
              isSelected: false,
              optionName: op,
              isTextField: false
            }));
            setOptions(newOptions);
          } else {
            setOptions([]);
          }
        }
      }
    } catch (error) {
      console.error("Error refreshing challenge status after answer:", error);
    }
  };

  const handleDontKnowRemember = async (answerTypeId) => {
    if (!userId || !currentQuestion) return;
    try {
      const obj = {
        UserId: Number(userId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            UserId: Number(userId),
            UserQuizId: currentQuestion.id,
            AnswerTypeId: answerTypeId,
            Answer: "",
            Answer1: "",
            Answer2: "",
            Answer3: "",
            Answer4: "",
            Answer5: "",
            Answer6: "",
            Answer7: "",
            Answer8: "",
            Answer9: ""
          }
        ]
      };
      await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj, accessToken);
      handleQuestionSubmit();
    } catch (error) {
      console.error("Error submitting alternative answer:", error);
    }
  };

  if (loading && !summary) {
    return (
      <Card sx={{ p: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress size={30} />
      </Card>
    );
  }



  const answeredCount = summary?.questionsAnswered ?? 0;
  const totalCount = summary?.totalQuestions ?? 5;
  const isCompleted = summary?.completed ?? false;
  const streak = summary?.currentStreak ?? 0;
  const rewardBucks = summary?.rewardBucks ?? 20;

  const streakModulo = streak % 5;
  const daysLeftForBonus = 5 - streakModulo;

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Card
        sx={{
          borderRadius: "16px",
          border: `1.5px solid`,
          borderColor: isCompleted ? "#c7d9bb" : "rgba(8, 61, 184, 0.15)",
          overflow: "hidden",
          animation: !isCompleted ? "glow-border 6s infinite ease-in-out" : "none",
          transition:
            "transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: isCompleted
              ? "0 20px 40px rgba(199, 217, 187, 0.4)"
              : "0 20px 40px rgba(8, 61, 184, 0.08)"
          }
        }}>
        <CardContent sx={{ p: 3 }}>
          {/* Header */}
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2
            }}>
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                gap: 1.2
              }}>
              <CheckCircleIcon sx={{ color: isCompleted ? "#28A745" : "#8D8D8D", fontSize: 24 }} />
              <Box>
                <Typography
                  variant="h6"
                  fontWeight="800"
                  color="text.primary"
                  sx={{ letterSpacing: "-0.5px", lineHeight: 1.25 }}>
                  Daily Builder Challenge
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight="700"
                  sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.25 }}>
                  <AccessTimeIcon sx={{ fontSize: 14, color: "#083DB8" }} />
                  Resets in:{" "}
                  <span
                    style={{
                      color: "#083DB8",
                      fontFamily: "monospace",
                      fontSize: "12px",
                      fontWeight: "800"
                    }}>
                    {timeRemaining}
                  </span>{" "}
                  (UTC)
                </Typography>
              </Box>
            </Stack>
            {streak > 0 && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={0.5}
                sx={{
                  backgroundColor: "#FFF4E5",
                  borderRadius: "20px",
                  px: 1.8,
                  py: 0.6,
                  border: "1px solid #FFE0B2",
                  animation: "pulse-flame 2.5s infinite ease-in-out"
                }}>
                <WhatshotIcon sx={{ color: "#FF9800", fontSize: 20 }} />
                <Typography variant="body2" fontWeight="800" sx={{ color: "#E65100" }}>
                  {streak} {streak === 1 ? "day streak" : "days streak"}
                </Typography>
              </Stack>
            )}
          </Stack>

          {/* Completed State Banner */}
          {isCompleted && (
            <Box
              sx={{
                backgroundColor: "#E8F5E9",
                border: "1px solid #C8E6C9",
                borderRadius: "12px",
                p: 1.5,
                mb: 2.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                animation: "slide-up 0.4s ease-out"
              }}>
              <Typography variant="body2" fontWeight="700" color="#2E7D32">
                🎉 Challenge Completed
              </Typography>
            </Box>
          )}

          {/* Info Details */}
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2.5
            }}>
            <Box>
              <Typography
                variant="h6"
                fontWeight="800"
                color="text.primary"
                sx={{ fontSize: "17px" }}>
                {answeredCount}/{totalCount} questions answered
              </Typography>
              {isCompleted ? (
                <Typography variant="body2" color="text.secondary" fontWeight="500">
                  Final Reward
                </Typography>
              ) : (
                <Typography variant="body2" color="text.secondary" fontWeight="500">
                  +{rewardBucks} Builder Bucks earned today
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                backgroundColor: "#083DB8",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: "16px",
                px: 2.2,
                py: 0.8,
                fontSize: "16px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                boxShadow: "0 4px 10px rgba(8, 61, 184, 0.25)"
              }}>
              +{rewardBucks}
              <img src={bucksIcon} alt="BuilderBucks" style={{ width: 22, height: 22 }} />
            </Box>
          </Stack>

          {/* 5-segment Progress Bars */}
          <Grid container spacing={1.2} mb={2.5}>
            {[0, 1, 2, 3, 4].map((index) => {
              const isActive = index < answeredCount;
              return (
                <Grid item xs={2.4} key={index}>
                  <Box
                    sx={{
                      height: "10px",
                      borderRadius: "6px",
                      backgroundColor: isActive ? BIBlue : BIGrey,
                      boxShadow: isActive ? "0 2px 5px rgba(8, 61, 184, 0.25)" : "none",
                      transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>

          {/* Bonus Unlock Notice */}
          {!isCompleted && (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2.5 }}>
              <WhatshotIcon
                sx={{ color: "#FF9800", fontSize: 18, animation: "pulse-flame 2.5s infinite" }}
              />
              <Typography variant="body2" color="#E65100" fontWeight="700">
                {daysLeftForBonus} more {daysLeftForBonus === 1 ? "day" : "days"} to unlock +20
                Builder Bucks bonus!
              </Typography>
            </Stack>
          )}

          {/* Call to Action button */}
          <Button
            variant="outlined"
            fullWidth
            onClick={
              isCompleted
                ? () => {
                    setJustCompleted(false);
                    setShowCompleteModal(true);
                  }
                : handleStartChallenge
            }
            sx={{
              textTransform: "none",
              borderRadius: "12px",
              borderColor: "#d8d8d8",
              color: "text.primary",
              fontWeight: "800",
              fontSize: "15px",
              py: 1.2,
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                borderColor: "#083DB8",
                backgroundColor: "rgba(8, 61, 184, 0.03)",
                color: "#083DB8"
              }
            }}>
            {isCompleted ? "View Challenge Summary" : "View Challenge"}
          </Button>
        </CardContent>
      </Card>

      {/* Quest Modal */}
      <Dialog
        open={showQuestModal}
        onClose={() => setShowQuestModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "20px", p: 1.5 }
        }}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
            pt: 2.5,
            px: 3
          }}>
          <Typography variant="h5" fontWeight="900" sx={{ letterSpacing: "-0.5px" }}>
            Daily Builder Challenge
          </Typography>
          <IconButton
            onClick={() => setShowQuestModal(false)}
            sx={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 0, px: 3, pb: 3 }}>
          {/* Stepper progress indicator */}
          <Stack
            sx={{
              flexDirection: "row",
              gap: 1,
              mb: 2.5,
              mt: 0.5,
              width: "100%"
            }}>
            {questions.map((q, idx) => {
              const isAnswered = q.isAnswer;
              const isCurrent = currentQuestion && q.id === currentQuestion.id;
              return (
                <Box
                  key={q.id}
                  sx={{
                    flex: 1,
                    height: "8px",
                    borderRadius: "4px",
                    backgroundColor: isAnswered ? BIBlue : BIGrey,
                    transition: "all 0.3s ease"
                  }}
                />
              );
            })}
          </Stack>

          {currentQuestion && (
            <Box>
              <EarnBuilderBucksCard
                key={currentQuestion.id}
                id={currentQuestion.id}
                getQuestions={handleQuestionSubmit}
                question={currentQuestion}
                remainingQuestion=""
                config="view-edit"
                prevQueId={currentQuestion.id}
                setLoadingData={() => {}}
                from="daily-challenge"
                options={options}
                selectedSite={selectedSite}
                setSelectedSite={setSelectedSite}
                fromDashboard="daily-challenge"
                setVisibleQuestions={handleQuestionSubmit}
                setAnswercount={() => {}}
              />
              <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 1, px: 0.5 }}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => handleDontKnowRemember(6)}
                  sx={{
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: "700",
                    borderColor: "#d8d8d8",
                    color: "#8D8D8D",
                    "&:hover": {
                      borderColor: "#083DB8",
                      backgroundColor: "rgba(8, 61, 184, 0.05)",
                      color: "#083DB8"
                    }
                  }}>
                  I don't know
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => handleDontKnowRemember(5)}
                  sx={{
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: "700",
                    borderColor: "#d8d8d8",
                    color: "#8D8D8D",
                    "&:hover": {
                      borderColor: "#083DB8",
                      backgroundColor: "rgba(8, 61, 184, 0.05)",
                      color: "#083DB8"
                    }
                  }}>
                  I don't remember
                </Button>
              </Stack>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Challenge Completed Success Modal */}
      <Dialog
        open={showCompleteModal}
        onClose={() => setShowCompleteModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            p: 0,
            textAlign: "center",
            overflow: "visible",
            maxHeight: "none",
            width: "360px"
          }
        }}>
        <DialogContent
          sx={{ overflow: "visible", maxHeight: "none", position: "relative", p: 2.2, pb: 4.5 }}>
          {/* Confetti Explosion Container */}
          {showCompleteModal && (
            <Box sx={{ position: "", top: "25%", left: "50%", pointerEvents: "none" }}>
              {confettiParticles.map((styleProps, i) => (
                <Box key={i} sx={styleProps} />
              ))}
            </Box>
          )}

          <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
            <Box
              sx={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                backgroundColor: "#FFBC0A",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 6px 20px rgba(255, 188, 10, 0.4)",
                transform: "scale(1)",
                animation: "pulse-flame 3s infinite"
              }}>
              <EmojiEventsIcon sx={{ fontSize: 40, color: "#fff" }} />
            </Box>
          </Box>

          <Typography variant="h5" fontWeight="900" gutterBottom sx={{ letterSpacing: "-0.5px" }}>
            Challenge Complete!
          </Typography>
          <Typography variant="body2" color="text.secondary" fontWeight="500" sx={{ mb: 2 }}>
            Great work — you answered all 5 questions today.
          </Typography>

          {/* Builder Bucks earned box */}
          <Box
            sx={{
              backgroundColor: "#083DB8",
              borderRadius: "16px",
              p: 2,
              color: "#fff",
              mb: 2,
              boxShadow: "0 8px 30px rgba(8, 61, 184, 0.25)"
            }}>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 0.5, fontWeight: "600" }}>
              Builder Bucks earned
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                mb: 2
              }}>
              <Typography
                variant="h3"
                fontWeight="900"
                sx={{ color: "#FFBC0A", textShadow: "0 2px 4px rgba(0,0,0,0.15)" }}>
                +{totalRewardBucks}
              </Typography>
              <img
                src={bucksIcon}
                alt="BuilderBucks"
                style={{ width: 34, height: 34, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.15))" }}
              />
            </Box>
            <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.15)", pt: 2 }}>
              <Typography variant="body2" sx={{ opacity: 0.8, fontWeight: "600", mb: 0.5 }}>
                Current Builder Bucks balance
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.75 }}>
                <Typography
                  variant="h5"
                  fontWeight="900"
                  sx={{
                    animation: isCounterActive ? "countup-effect 0.2s ease-out infinite" : "none"
                  }}>
                  {animatedBalance}
                </Typography>
                <img src={bucksIcon} alt="BuilderBucks" style={{ width: 22, height: 22 }} />
              </Box>
            </Box>
          </Box>

          {/* Streak details */}
          {streak > 0 && (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={1}
              sx={{
                backgroundColor: "#FFF8E1",
                borderRadius: "12px",
                py: 1.5,
                mb: 3,
                border: "1px solid #FFE082"
              }}>
              <WhatshotIcon sx={{ color: "#FF8F00", animation: "pulse-flame 2.5s infinite" }} />
              <Typography variant="subtitle2" fontWeight="800" color="#C62828">
                {streak} {streak === 1 ? "day challenge streak" : "days challenge streak"}
              </Typography>
            </Stack>
          )}

          <Typography variant="body2" color="text.secondary" fontWeight="500" sx={{ mb: 4 }}>
            Builder Bucks can be redeemed in the Rewards Store or used to enter company prize draws.
          </Typography>

          <Stack direction="row" spacing={1.5} sx={{ mt: 2.5 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setShowCompleteModal(false);
                navigate("/reward-store/my-store");
              }}
              sx={{
                backgroundColor: "#083DB8",
                py: 1,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: "800",
                fontSize: "15px",
                boxShadow: "0 4px 15px rgba(8, 61, 184, 0.3)",
                "&:hover": {
                  backgroundColor: "#062A85",
                  boxShadow: "0 6px 20px rgba(8, 61, 184, 0.4)"
                }
              }}>
              Redeem Now
            </Button>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => setShowCompleteModal(false)}
              sx={{
                py: 1,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: "800",
                fontSize: "15px",
                borderColor: "#083DB8",
                color: "#083DB8",
                transition: "all 0.2s ease",
                "&:hover": {
                  borderColor: "#062A85",
                  backgroundColor: "rgba(8, 61, 184, 0.05)"
                }
              }}>
              Done
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Daily Builder Challenge Start Modal */}
      <Dialog
        open={showStartModal}
        onClose={() => setShowStartModal(false)}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "transparent !important",
            backgroundImage: "none !important",
            boxShadow: "none !important",
            overflow: "visible"
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: "24px",
            p: 0,
            textAlign: "center",
            overflow: "visible",
            maxHeight: "none",
            width: "360px"
          }
        }}>
        <Box
          sx={{
            overflow: "visible",
            position: "relative",
            backgroundColor: "white",
            borderRadius: "24px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
          }}>
          {/* Top dark blue banner */}
          <Box
            sx={{
              backgroundColor: "#083DB8",
              height: "80px",
              borderTopLeftRadius: "24px",
              borderTopRightRadius: "24px"
            }}
          />

          {/* Overlapping mascot trophy */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: "-40px",
              position: "relative",
              zIndex: 2,
              mb: 2
            }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                backgroundColor: "#FFBC0A",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 6px 20px rgba(255, 188, 10, 0.4)",
                border: "4px solid #fff"
              }}>
              <EmojiEventsIcon sx={{ fontSize: 45, color: "#fff" }} />
            </Box>
          </Box>

          <Typography
            variant="h5"
            fontWeight="900"
            sx={{ px: 3, mb: 1, letterSpacing: "-0.5px", color: "text.primary" }}>
            Daily Builder Challenge
          </Typography>
          <Typography variant="body2" color="text.secondary" fontWeight="500" sx={{ px: 3, mb: 2 }}>
            5 quick questions. Builder Bucks every day.
          </Typography>

          <Box sx={{ borderBottom: "1px solid #e9ecef", mx: 3, mb: 2.5 }} />

          <Typography
            variant="body2"
            fontWeight="600"
            sx={{ px: 3, mb: 3, lineHeight: 1.5, color: "#4A4A4A" }}>
            Answer 5 quick questions every day to earn Builder Bucks. Use them in the{" "}
            <span style={{ color: "#083DB8", fontWeight: "800" }}>Rewards Store</span> or enter
            prize draws for company rewards.
          </Typography>

          {/* Today's reward box */}
          <Box sx={{ px: 3, mb: 2 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{ mb: 1, justifyContent: "center" }}>
              <EmojiEventsIcon sx={{ fontSize: 16, color: "#8D8D8D" }} />
              <Typography
                variant="caption"
                fontWeight="800"
                color="#8D8D8D"
                sx={{ letterSpacing: "1px" }}>
                TODAY'S REWARD
              </Typography>
            </Stack>
            <Stack
              direction="row"
              sx={{
                backgroundColor: "#FFF8E1",
                border: "1px solid #FFE082",
                borderRadius: "16px",
                py: 2,
                px: 2.5,
                alignItems: "center",
                justifyContent: "center",
                gap: 1
              }}>
              <img src={bucksIcon} alt="BuilderBucks" style={{ width: 24, height: 24 }} />
              <Typography variant="h6" fontWeight="900" color="#E65100">
                +{rewardBucks} Builder Bucks
              </Typography>
            </Stack>
          </Box>

          {/* Streak box */}
          <Box sx={{ px: 3, mb: 3 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{
                backgroundColor: "#F5F5F5",
                borderRadius: "16px",
                p: 2,
                textAlign: "left"
              }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                }}>
                <WhatshotIcon sx={{ color: "#FF9800" }} />
              </Box>
              <Box>
                <Typography
                  variant="subtitle2"
                  fontWeight="800"
                  color="text.primary"
                  sx={{ lineHeight: 1.2 }}>
                  {streak} day streak
                </Typography>
                <Typography variant="caption" color="text.secondary" fontWeight="600">
                  Complete 5 days in a row to earn an extra +20 Builder Bucks.
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Actions */}
          <Box sx={{ px: 3, pb: 4 }}>
            <Button
              variant="contained"
              fullWidth
              disabled={maybeLaterLoading}
              onClick={() => {
                setShowStartModal(false);
                handleStartChallenge();
              }}
              sx={{
                backgroundColor: "#083DB8",
                py: 1.5,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: "800",
                fontSize: "16px",
                mb: 2,
                boxShadow: "0 4px 15px rgba(8, 61, 184, 0.3)",
                "&:hover": {
                  backgroundColor: "#062A85",
                  boxShadow: "0 6px 20px rgba(8, 61, 184, 0.4)"
                }
              }}>
              Start Challenge &rarr;
            </Button>
            <Button
              variant="text"
              fullWidth
              disabled={maybeLaterLoading}
              onClick={handleMaybeLater}
              sx={{
                color: "#8D8D8D",
                fontWeight: "700",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#083DB8"
                }
              }}>
              {maybeLaterLoading ? <CircularProgress size={20} color="inherit" /> : "Maybe Later"}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default DailyChallengeCard;
